<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        <br />
        <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        <br />
        <v-skeleton-loader ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="6">
        <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" md="4" v-for="i in 3" :key="i">
        <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
        <br />
        <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        <v-skeleton-loader ref="skeleton" type="list-item-two-line"></v-skeleton-loader>
        <v-row align="center" justify="center">
          <v-skeleton-loader ref="skeleton" type="button"></v-skeleton-loader>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomeSkeleton"
};
</script>